export const LOCAL_STORAGE_SHOW_MINIMIZABLE_MODAL_TOOLTIP = 'show_minimizable_modal_tooltip';
